var map = {
	"./Foods.js": "52de",
	"./Global.js": "6df7",
	"./Ingredients.js": "8526",
	"./Meal.js": "c0e4",
	"./MealPlan.js": "d56c",
	"./MealPlans.js": "401f",
	"./Meals.js": "c3bf",
	"./Methods.js": "7fbc",
	"./Recipe.js": "ee24",
	"./Recipes.js": "460f",
	"./Settings.js": "f162",
	"./ShoppingList.js": "63dd",
	"./Streams.js": "0cc1",
	"./index.js": "7869"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5f40";